var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style)},[_c('div',{staticClass:"title-component",class:[`type-${_vm.value.type.name}`]},[_c('span',{staticClass:"split-before",style:(_vm.typeStyle)}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.value.text))]),_c('span',{staticClass:"split-after",style:(_vm.typeStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }